import { ShopContactType } from '../enum/shop-contact-type.enum';
import { SocialPlatform } from '../enum/social-platform.enum';
import { ShopContact } from './shop-contact.model';
import { ShopProfilePicture } from './shop-profile-picture.model';
import { SocialProfile } from './social-profile.model';
import { User } from './user.model';

export class ShopInfo {
    aboutOwner = '';
    description = '';
    shopName = '';
    shopPk = '';
    shopUid = '';
    socialProfile: SocialProfile[] = [];
    status = '';
    user: User;
    lineLink = '';
    facebookLink = '';
    instagramLink = '';
    twitterLink = '';
    youtubeLink = '';
    tiktokLink = '';
    phone = '';
    email = '';
    shopContact: ShopContact[] = [];
    profilePicture: ShopProfilePicture;

    constructor(shop = null) {
        if (shop) {
            this.aboutOwner = shop.aboutOwner || this.aboutOwner;
            this.description = shop.description || this.description;
            this.shopName = shop.name || this.shopName;
            this.shopPk = shop.pk || this.shopPk;
            this.shopUid = shop.shopUid || this.shopUid;
            if (shop.socialProfile && shop.socialProfile.length > 0) {
                for (const profile of shop.socialProfile) {
                    this.socialProfile.push(new SocialProfile(profile));
                }
                const line = this.socialProfile.find(s => s.platform === SocialPlatform.LINE);
                this.lineLink = line ? line.url : this.lineLink;
                const fb = this.socialProfile.find(s => s.platform === SocialPlatform.FACEBOOK);
                this.facebookLink = fb ? fb.url : this.facebookLink;
                const insta = this.socialProfile.find(s => s.platform === SocialPlatform.INSTAGRAM);
                this.instagramLink = insta ? insta.url : this.instagramLink;
                const youtube = this.socialProfile.find(s => s.platform === SocialPlatform.YOUTUBE);
                this.youtubeLink = youtube ? youtube.url : this.youtubeLink;
                const twitter = this.socialProfile.find(s => s.platform === SocialPlatform.TWITTER);
                this.twitterLink = twitter ? twitter.url : this.twitterLink;
                const tiktok = this.socialProfile.find(s => s.platform === SocialPlatform.TIKTOK);
                this.tiktokLink = tiktok ? tiktok.url : this.tiktokLink;
            }

            this.status = shop.status || this.status;
            this.user = new User(shop.user);

            if (shop.shopContact && shop.shopContact.length > 0) {
                for (const contact of shop.shopContact) {
                    this.shopContact.push(new ShopContact(contact));
                }
                const phone = this.shopContact.find(c => c.contactType === ShopContactType.PHONE);
                this.phone = phone ? phone.info : this.phone;
                const email = this.shopContact.find(c => c.contactType === ShopContactType.EMAIL);
                this.email = email ? email.info : this.email;
            }
            this.profilePicture = new ShopProfilePicture(shop.profilePicture);
        }
    }
}
